// ─── theme.js ─────────────────────────────────────────────────────────────────
// Full Emotion theme object. Passed to <ThemeProvider> at the app root.
// Access in any styled component via: ${({ theme }) => theme.colors.text.primary}
// ─────────────────────────────────────────────────────────────────────────────

import {colors, palette} from './colors'

export const theme = {
  colors,
  palette, // raw palette also available for one-off uses

  // ── Typography ─────────────────────────────────────────────────────────────
  // fonts.body    : all body text, inputs, buttons, labels
  // fonts.heading : h1–h4 and page titles
  // fonts.mono    : code blocks, technical strings
  // Change one line here to retheme fonts across the entire app.

  fonts: {
    body: "'Inter', 'Helvetica Neue', Arial, sans-serif",
    heading: "'Inter', 'Helvetica Neue', Arial, sans-serif",
    mono: "'JetBrains Mono', 'Fira Code', 'Courier New', monospace",
    openSans: "'Open Sans', Arial, sans-serif",
  },
  fontSizes: {
    xxs: '10px',
    xs: '11px',
    sm: '12px',
    md: '13px',
    base: '14px',
    lg: '15px',
    xl: '16px',
    '2xl': '18px',
    '3xl': '20px',
  },

  fontWeights: {
    regular: 400,
    medium: 500,
    semibold: 600,
    bold: 700,
  },

  // ── Spacing ────────────────────────────────────────────────────────────────
  space: {
    0.5: '2px',
    1: '4px',
    1.25: '5px',
    1.5: '6px',
    2: '8px',
    2.5: '10px',
    3: '12px',
    4: '16px',
    5: '20px',
    6: '24px',
    8: '32px',
    10: '40px',
    12: '48px',
    13: '52px',
    14: '56px',
  },

  // ── Border radius ──────────────────────────────────────────────────────────
  radii: {
    xs: '2px',
    sm2: '4px',
    sm: '4px',
    md2: '5px',
    md: '6px',
    lg: '8px',
    lg2: '10px',
    xl: '12px',
    full: '9999px',
  },

  // ── Shadows ────────────────────────────────────────────────────────────────
  shadows: {
    sm: '#0000000f 0 1px 3px, #0000001a 0 1px 2px',
    md: '#0000001f 0 4px 12px, #0000003d 0 2px 4px',
    lg: '#00000029 0 8px 24px, #0000004d 0 4px 8px',
    focus: `0 0 0 3px ${colors.border.focus}33`,
  },

  // ── Transitions ────────────────────────────────────────────────────────────
  transitions: {
    fast: '0.1s ease',
    normal: '0.15s ease',
    slow: '0.25s ease',
  },

  // ── Z-index scale ──────────────────────────────────────────────────────────
  zIndex: {
    base: 0,
    dropdown: 100,
    sticky: 200,
    overlay: 500,
    modal: 1000,
    toast: 1100,
  },
}
